import { Container, Paper } from "@mui/material";

import Layout from "components/Layout";
import BotNotesPanel from "containers/BotNotesPanel";
import { useViewAs } from "hooks/useViewAs";
import { canEditBotNotes } from "utils/roles";

/** The notes screen on its own, at its own address: the notes of the bots, for
 *  whoever operates Automations. */
export default function BotNotesPage() {
  const { realProfile, readOnly } = useViewAs();
  return (
    <Layout title="Bot Notes" content="Bot Notes">
      <Container
        component="main"
        maxWidth={false}
        sx={{ py: 3, px: { xs: 1.5, sm: 3 } }}
      >
        <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2.5 } }}>
          <BotNotesPanel canEdit={canEditBotNotes(realProfile) && !readOnly} />
        </Paper>
      </Container>
    </Layout>
  );
}
